module.exports = __webpack_public_path__ + "img/project-nonconformities.5245b5b7.svg";